export interface GoogleSignupIdentity {
  email: string;
  name: string;
  credential: string;
  nonce: string;
}

// Keep the Google credential in memory only while moving from login to signup.
let pending: GoogleSignupIdentity | null = null;
export function setPendingGoogleSignup(identity: GoogleSignupIdentity | null) {
  pending = identity;
}
export function getPendingGoogleSignup() {
  return pending;
}
